import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import { getRoleModules } from "reduxStore/action/moduleActions";
import { createRole, roleDetail } from "reduxStore/action/roleActions";
import strings from "translate/language";
import { errorToast } from "utils/httpClient";
import { seo } from "utils/utils";
import Breadcrumb from "component/common/breadcrumb";
import Button from "../../component/Button";

const EditRoles = () => {
  const navigate = useNavigate();

  const [formVaild, setFormVaild] = useState(false);

  const params = useParams();
  const { role_id = "" } = params || {};
  const [form, setForm] = useState({
    role_title: "",
  });
  const [showPropertOption, setShowPropertOption] = useState({});

  const dispatch = useDispatch();
  const modulesSelector =
    useSelector((state) => state.modules.response?.data) || [];
  const rolesSelector = useSelector((state) => state.roleData) || {};

  useEffect(() => {
    dispatch(getRoleModules(""));
  }, []);

  useEffect(() => {
    if (rolesSelector?.create === true) {
      if (rolesSelector?.response?.status === 200) {
        navigatpage("/roles");
      } else {
        errorToast(rolesSelector?.response?.message);
      }
    }
    if (rolesSelector.detail === true) {
      const { response } = rolesSelector;
      if (response?.status === 200) {
        setForm({ ...form, role_title: response?.data[0]?.role_title });
        const data = Object.fromEntries(
          response?.data[0]?.permission_module.map((i) => [i._id, true])
        );
        setShowPropertOption(data);
      } else {
        errorToast(response?.message);
      }
    }
  }, [rolesSelector]);

  useEffect(() => {
    dispatch(roleDetail({ role_id: role_id }));
  }, []);
  const navigatpage = async (navname) => {
    navigate(navname);
  };
  const handleInputField = (e) => {
    const nextFormState = {
      ...form,
      [e.target.name]: e.target.value,
    };
    setForm(nextFormState);
  };

  const handleSubmit = () => {
    if (form.role_title === "") {
      setFormVaild(true);

      return true;
    } else {
      setFormVaild(false);
      const filtered = Object.keys(showPropertOption).filter(
        (i) => showPropertOption[i] === true
      );
      let permission_module = filtered.map((item) => item).join(",");
      const post = {
        role_id: role_id,
        role_title: form.role_title,
        permission_module: permission_module,
      };
      dispatch(createRole(post));
    }
  };
  useEffect(() => {
    seo({
      title: "Edit Role",
      metaDescription: "Edit Role",
      canonicalLink: window.location.href,
    });
  }, []);
  return (
    <div className="page-body">
      <Breadcrumb
        title={strings.editrole}
        url={"/roles"}
        parentListing={strings.roleListing}
        titleactive={strings.editrole}
        isBackBtn={true}
      />
      <div className="container-fluid">
        <div className="row">
          <div className="col-sm-12 col-xl-12">
            <div className="card">
              <div className="row">
                <div className="col-md-6 ml-3 pt-2">
                  <div className="form-group">
                    <h5>
                      {" "}
                      <label htmlFor="exampleFormControlLastName">
                        {strings.roleName}
                      </label>
                    </h5>
                    <input
                      className="form-control"
                      id="exampleFormControlLastName"
                      type="text"
                      autoComplete="off"
                      placeholder="Roles Name"
                      name="role_title"
                      value={form.role_title}
                      onChange={handleInputField}
                    />
                    {formVaild && (
                      <span style={{ color: "red" }}>{strings.rolename}</span>
                    )}
                  </div>
                </div>
                <div className="col-md-8 ml-3 pt-3">
                  <div className="form-group">
                    <h5>
                      <label htmlForhtmlFor="exampleFormControlLastName">
                        {strings.modules}
                      </label>
                    </h5>

                    {modulesSelector &&
                      modulesSelector.map((item, index) => (
                        <div className="col-md-12" key={index}>
                          <div className="card-body animate-chk pt-2">
                            <div className="row">
                              <div className="col-md-12">
                                <label
                                  className="d-block"
                                  htmlFor={"chk-ani" + index}
                                >
                                  <input
                                    className="checkbox_animated"
                                    id={"chk-ani" + index}
                                    type="checkbox"
                                    checked={
                                      showPropertOption[item?._id] || false
                                    }
                                    onChange={(e) =>
                                      setShowPropertOption({
                                        ...showPropertOption,
                                        [item?._id]: e.target.checked,
                                      })
                                    }
                                  />
                                  {item.module_title}
                                </label>
                                {showPropertOption[item._id] ? (
                                  <>
                                    {item.children &&
                                      item.children.map((item, index) => (
                                        <div className="ml-4" key={index}>
                                          <label
                                            className="d-block-sub"
                                            htmlFor={"chk-ani-k" + item._id}
                                          >
                                            <input
                                              className="checkbox_animated"
                                              id={"chk-ani-k" + item._id}
                                              type="checkbox"
                                              checked={
                                                showPropertOption[item?._id] ||
                                                false
                                              }
                                              onChange={(e) =>
                                                setShowPropertOption({
                                                  ...showPropertOption,
                                                  [item?._id]: e.target.checked,
                                                })
                                              }
                                            />
                                            {item.module_title}
                                          </label>
                                          <br />
                                        </div>
                                      ))}
                                  </>
                                ) : null}
                              </div>
                            </div>
                          </div>
                        </div>
                      ))}
                  </div>
                </div>
              </div>

              <div className="row pt-3 pr-3">
                <div className="col-md-12 ">
                  <div className="form-group d-flex justify-content-end">
                    <Button
                      className="btn btn-color"
                      onClick={() => handleSubmit()}
                      label={strings.update}
                    ></Button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
export default EditRoles;
